

export default function HeadingTitle({title, id}) {
    return (
        <h2 className="font-weight-extra-bold text-7 my-2 line-height-2 text-secondary" id={id}>
            {title} 
        </h2>
    )
}
